'use client'

import { usePathname } from 'next/navigation'
import UnpaidOrderNotice from '@/components/common/UnpaidOrderNotice'
import styles from './FloatButton.module.css'

export default function FloatButton({ storeInfo }) {
  const pathname = usePathname()

  const instagramEnable = storeInfo?.IsShowIGFloatingButton
  const instagramUrl = storeInfo?.IGFloatingURL

  const facebookEnable = storeInfo?.IsShowFBFloatingButton
  const facebookUrl = storeInfo?.FBFloatingURL

  // 判斷是否為商品列表詳細頁 /product-list/{id}
  const isProductListPage = /^\/product-list\/[^/]+\/?$/.test(pathname ?? '')

  // 如果是商品列表詳細頁，就不顯示任何懸浮球
  if (isProductListPage) {
    return null
  }

  return (
    <div className={styles.floatContainer}>
      {/* 未付款訂單 */}
      <UnpaidOrderNotice />

      {/* Instagram */}
      {instagramEnable && instagramUrl && (
        <a
          href={instagramUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.socialButton}
          aria-label="Instagram"
        >
          <img
            src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/instagram.svg"
            alt="Instagram"
          />
        </a>
      )}

      {/* Facebook */}
      {facebookEnable && facebookUrl && (
        <a
          href={facebookUrl}
          target="_blank"
          rel="noopener noreferrer"
          className={styles.socialButton}
          aria-label="Facebook"
        >
          <img
            src="https://cdn.jsdelivr.net/npm/simple-icons@v9/icons/facebook.svg"
            alt="Facebook"
          />
        </a>
      )}
    </div>
  )
}
